import React from 'react';
import { Modal, Divider, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

import ModalHeader from '../../drive/ModalHeader';
import ModalFooter from '../../drive/ModalFooter';
import ContactUsImage from "../../../images/grafix-banner/artboard.svg";


class DeactivatedAccountInfoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    close = () => {
        let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
        if (account.role === 'user' && this.props.user.accounts.length > 1) {
            this.props.logoClick(true);
        }
        dispatch.account.setDeActivateAccountModal(false);
    }

    logout = () => {
        dispatch.login.logout();
    }

    changeAccountSelection = () => {
        dispatch.account.setDeActivateAccountModal(false);
        this.props.logoClick(true);
    }

    render() {
        let allAccountsDeactivated = false;
        let singleAccount = false;
        let disableCloseIcon = true;

        if (this.props.user && this.props.user.accounts.length > 1) {
            let activeAccounts = this.props.user.accounts.filter(account => { return account.isActive === true })
            if (activeAccounts.length === 0) {
                allAccountsDeactivated = true;
            }
        } else {
            singleAccount = true;
        }

        let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
        if (this.props.user && this.props.user.accounts.length <= 1) {
            disableCloseIcon = false;
            if (account.role === 'customerAdmin') {
                disableCloseIcon = true;
            }
        }

        return (
            <Modal
                className="basicModal"
                open={this.props.deActivateAccountModal}
                onClose={this.close}
                closeOnEscape={false}
                closeOnDimmerClick={false}
                closeIcon={false}
                size="small"

            >
                <ModalHeader
                    subHeader={`Hello ${this.props.user && this.props.user.firstName}`}
                    subText={this.props.selectedAccount && account.role === 'customerAdmin' ? 'Your account has been deactivated.' : this.props.selectedAccount.name + ' has been deactivated.'} />
                {
                    account.role === 'customerAdmin' ?
                        <ModalHeader
                            header={`Deactivation reason`}
                            subText={
                                <div dangerouslySetInnerHTML={{ __html: this.props.selectedAccount && this.props.selectedAccount.actionLogs && this.props.selectedAccount.actionLogs.length > 0 && this.props.selectedAccount.actionLogs[this.props.selectedAccount.actionLogs.length - 1].reason }} />} />

                        : null
                }
                <Modal.Content className="ModalContent pad_0">
                    <div className="ModalContent">
                        <div ><img src={`${ContactUsImage}`} height="160" alt='' /> </div>
                        <div className={`error_text2`} style={{ color: '#FF931E' }}>Contact Us</div>
                        {
                            account.role === 'customerAdmin' ?
                                <span className="error_text3">Get in touch with our platform admin to Reactivate your account. <br />
                                    Email :  <a href="#" href="mailto:support@aspenify.com" target="_blank" > support@aspenify.com</a> <br />
                                    Phone : +91 7897 5898 38
                                </span>
                                : <span className="error_text3">Get in touch with your account owner to Reactivate your account. <br /></span>
                        }
                        <br />
                        {
                            singleAccount || allAccountsDeactivated ?
                                <Button style={{ marginTop: "7px" }} className="button-submit" onClick={this.logout} >Logout</Button>
                                : <Button style={{ marginTop: "7px" }} className="button-submit" onClick={this.changeAccountSelection} >Select another account</Button>
                        }
                    </div>
                    <Divider className="mar_0" />
                    <ModalFooter text={
                        <p className="f_10"><strong>What happens to my data? </strong><p>Don't worry all your data is safe. <br /> You can access it once your account gets reactivated. </p></p>
                    } />
                </Modal.Content>
            </Modal>
        )
    }
}

export default DeactivatedAccountInfoModal;